import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {unwrapResult} from '@reduxjs/toolkit';
import {toast} from 'react-toastify';
import {t} from '@lingui/core/macro';

import MainModal from 'shared/ui/Modal/MainModal';
import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import Problem from 'shared/ui/icons/General/Problem';
import {IUserOutput, disableRecurring, fetchMe} from 'entities/user';
import {TypedDispatch} from 'shared/model/types';

import {PALETTE} from 'shared/config/model/palette';

import ModalBlockButton from '../../../../shared/ui/Button/ModalBlockButton/ModalBlockButton';

import styles from './DisableAutoRenewalModal.module.scss';

interface IAddAutoRenewalModalProps {
    isOpen: boolean;
    handleClose: () => void;
    item?: IUserOutput | null;
}

const DisableAutoRenewalModal: React.FC<IAddAutoRenewalModalProps> = ({isOpen, handleClose, item}) => {
    const dispatch = useDispatch<TypedDispatch>();

    // eslint-disable-next-line max-len
    const TEXT = t`Без автопродления есть риск пропустить оплату и тариф автоматически сменится на бесплатный с ограничениями по мониторингу.`

    const onClickConfirm = useCallback(async() => {
        const resultAction = await dispatch(disableRecurring());
        const result = unwrapResult(resultAction);
        if (result.status) {
            toast.info(result.message);
            await dispatch(fetchMe());
            handleClose();
        } else {
            toast.info(result.message);
        }
    }, [dispatch, handleClose]);
    
    return (
        <MainModal
            header={t`Автопродление`}
            open={isOpen}
            handleClose={handleClose}
            className={styles.autoRenewalModal}
        >
            <>
                <ModalBodyWrapper>
                    <div className={styles.content}>
                        <div className={styles.icon}>
                            <Problem color={PALETTE.warningDark}/>
                        </div>
                        <span className={styles.title}>
                            {t`Вы уверены, что хотите отключить автопродление тарифа`} «{item?.tariff?.name}»?
                        </span>
                        <span className={styles.text}>
                            {TEXT}
                        </span>
                    </div>
                </ModalBodyWrapper>
                <ModalBlockButton
                    primaryButtonText={t`Отключить`}
                    primaryButtonType="button"
                    primaryButtonOnClick={onClickConfirm}
                    secondaryButtonOnClick={handleClose}
                />
            </>
        </MainModal>
    );
};

export default DisableAutoRenewalModal;